
function GetCurrentUser() {
    const user = localStorage.getItem('currentMUDEKUser');
    const resp = user != null ? JSON.parse(JSON.parse(JSON.stringify(user.toString()))) : user;
    return resp;
}

function SetCurrentUser(user) {
    localStorage.setItem('currentMUDEKUser', user);
}

export default {
    GetCurrentUser,
    SetCurrentUser
};



